import { render, staticRenderFns } from "./tcyh.vue?vue&type=template&id=c6e22256&scoped=true&"
import script from "./tcyh.vue?vue&type=script&lang=js&"
export * from "./tcyh.vue?vue&type=script&lang=js&"
import style0 from "./tcyh.vue?vue&type=style&index=0&id=c6e22256&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e22256",
  null
  
)

export default component.exports